module.exports = __webpack_public_path__ + "img/Personal-Growth.13242037.png";